import React from 'react'
import QRCode from 'react-qr-code'


export const QRCodeDisplay = ({value}) => {

    return (
      <div style={{marginLeft:"16px"}} className="col-sm-8 col-sm-4 ml2">


          <QRCode 
            size="128"
            value={value}
          />

      </div>
    )

}
